import {
  DATA_ANALYTICS_KPI_START,
  DATA_ANALYTICS_KPI_SUCCESS,
  DATA_ANALYTICS_KPI_FAIL,
  DATA_ANALYTICS_TRENDS_START,
  DATA_ANALYTICS_TRENDS_SUCCESS,
  DATA_ANALYTICS_TRENDS_FAIL,
  DATA_ANALYTICS_EXCEPTIONS_START,
  DATA_ANALYTICS_EXCEPTIONS_SUCCESS,
  DATA_ANALYTICS_EXCEPTIONS_FAIL,
  DATA_ANALYTICS_PORTFOLIO_START,
  DATA_ANALYTICS_PORTFOLIO_SUCCESS,
  DATA_ANALYTICS_PORTFOLIO_FAIL,
  DATA_ANALYTICS_FILTER_OPTIONS_START,
  DATA_ANALYTICS_FILTER_OPTIONS_SUCCESS,
  DATA_ANALYTICS_FILTER_OPTIONS_FAIL,
  DATA_ANALYTICS_HIGH_RISK_DETAILS_START,
  DATA_ANALYTICS_HIGH_RISK_DETAILS_SUCCESS,
  DATA_ANALYTICS_HIGH_RISK_DETAILS_FAIL,
  DATA_ANALYTICS_HIGH_RISK_DETAILS_CLEAR,
} from '../../actions/DataAnalytics/ActionTypes';

const initialState = {
  kpiSummary: null,
  loadingKPI: false,
  kpiError: null,

  trendCharts: null,
  loadingTrends: false,
  trendsError: null,

  exceptionPanels: null,
  loadingExceptions: false,
  exceptionsError: null,

  portfolioHealth: null,
  loadingPortfolio: false,
  portfolioError: null,

  filterOptions: {
    contractGroups: [],
    contractSubGroups: [],
    contractTypes: [],
  },
  loadingFilterOptions: false,
  filterOptionsError: null,

  highRiskDetails: null,
  loadingHighRiskDetails: false,
  highRiskDetailsError: null,
};

const DataAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATA_ANALYTICS_KPI_START:
      return { ...state, loadingKPI: true, kpiError: null };
    case DATA_ANALYTICS_KPI_SUCCESS:
      return { ...state, loadingKPI: false, kpiSummary: action.data };
    case DATA_ANALYTICS_KPI_FAIL:
      return { ...state, loadingKPI: false, kpiError: action.error };

    case DATA_ANALYTICS_TRENDS_START:
      return { ...state, loadingTrends: true, trendsError: null };
    case DATA_ANALYTICS_TRENDS_SUCCESS:
      return { ...state, loadingTrends: false, trendCharts: action.data };
    case DATA_ANALYTICS_TRENDS_FAIL:
      return { ...state, loadingTrends: false, trendsError: action.error };

    case DATA_ANALYTICS_EXCEPTIONS_START:
      return { ...state, loadingExceptions: true, exceptionsError: null };
    case DATA_ANALYTICS_EXCEPTIONS_SUCCESS:
      return { ...state, loadingExceptions: false, exceptionPanels: action.data };
    case DATA_ANALYTICS_EXCEPTIONS_FAIL:
      return { ...state, loadingExceptions: false, exceptionsError: action.error };

    case DATA_ANALYTICS_PORTFOLIO_START:
      return { ...state, loadingPortfolio: true, portfolioError: null };
    case DATA_ANALYTICS_PORTFOLIO_SUCCESS:
      return { ...state, loadingPortfolio: false, portfolioHealth: action.data };
    case DATA_ANALYTICS_PORTFOLIO_FAIL:
      return { ...state, loadingPortfolio: false, portfolioError: action.error };

    case DATA_ANALYTICS_FILTER_OPTIONS_START:
      return { ...state, loadingFilterOptions: true, filterOptionsError: null };
    case DATA_ANALYTICS_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        loadingFilterOptions: false,
        filterOptions: {
          contractGroups: action.data.contract_groups || [],
          contractSubGroups: action.data.contract_sub_groups || [],
          contractTypes: action.data.contract_types || [],
        },
      };
    case DATA_ANALYTICS_FILTER_OPTIONS_FAIL:
      return { ...state, loadingFilterOptions: false, filterOptionsError: action.error };

    case DATA_ANALYTICS_HIGH_RISK_DETAILS_START:
      return { ...state, loadingHighRiskDetails: true, highRiskDetailsError: null };
    case DATA_ANALYTICS_HIGH_RISK_DETAILS_SUCCESS:
      return { ...state, loadingHighRiskDetails: false, highRiskDetails: action.data };
    case DATA_ANALYTICS_HIGH_RISK_DETAILS_FAIL:
      return { ...state, loadingHighRiskDetails: false, highRiskDetailsError: action.error };
    case DATA_ANALYTICS_HIGH_RISK_DETAILS_CLEAR:
      return { ...state, highRiskDetails: null, highRiskDetailsError: null };

    default:
      return state;
  }
};

export default DataAnalyticsReducer;
